/**
 * Read a wire vocabulary (``Record<key, description>``) into one whose every
 * description is a string, dropping the entries whose description is not. A
 * value that is not a plain object reads as an empty vocabulary.
 *
 * Deliberately preserves keys verbatim, including surrounding whitespace: a
 * saved key is the agent's own data, and trimming it here would silently
 * rename a label the moment an unrelated edit round-trips the goal.
 */
export function readVocabulary(raw: unknown): Record<string, string> {
  const vocab: Record<string, string> = {};
  if (typeof raw !== "object" || raw === null || Array.isArray(raw)) {
    return vocab;
  }
  for (const [key, description] of Object.entries(raw)) {
    if (typeof description === "string") {
      vocab[key] = description;
    }
  }
  return vocab;
}
